export class Geoutil {
    static getCircleArray(latlng: any, radius = 100, nPoints = 8) {
        //gets a latlng coord at center
        //gives back an array of coordinates describing the circle
        let lat = latlng.lat;
        let lng = latlng.lng;
        let fraction = Math.cos(this.toRad(lat));
        let meterarray: any = [];
        let latlngarray: any = [];
        for (let i = 0; i <= nPoints; i++) {
            let angle = this.toRad(i / nPoints * 360);
            let x = radius * Math.cos(angle);
            let y = radius * Math.sin(angle);
            meterarray.push({ x, y });
            // now add diff to latlng array
            let latlngnew = this.getDifLAtLong(latlng, x, y);
            latlngarray.push(latlngnew);
        }
        return latlngarray;
    }

    static getDifLAtLong(latlng: any,dx: number,dy:number){
        const r_earth = 6371000; //in meter

        let new_latitude  = latlng.lat  + (dy / r_earth) * (180 / Math.PI);
        let new_longitude = latlng.lng + (dx / r_earth) * (180 / Math.PI) / Math.cos(latlng.lat * Math.PI/180);
        return {lat: new_latitude,lng: new_longitude};
    }

    static getDistance(latlng1: any, latlng2: any) {
        const R = 6371; // km
        let dLat = this.toRad(latlng1.lat - latlng2.lat);
        let dLon = this.toRad(latlng1.lng - latlng2.lng);

        let lat1 = this.toRad(latlng1.lat);
        let lat2 = this.toRad(latlng2.lat);

        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c * 1000;
        return d;
    }

    static toRad(Value: number) {
        return Value * Math.PI / 180;
    }

    // https://www.algorithms-and-technologies.com/point_in_polygon/javascript
    /**
     * Performs the even-odd-rule Algorithm (a raycasting algorithm) to find out whether a point is in a given polygon.
     * This runs in O(n) where n is the number of edges of the polygon.
     *
     * @param {Array} polygon an array representation of the polygon where polygon[i][0] is the x Value of the i-th point and polygon[i][1] is the y Value.
     * @param {Array} point   an array representation of the point where point[0] is its x Value and point[1] is its y Value
     * @return {boolean} whether the point is in the polygon (not on the edge, just turn < into <= and > into >= for that)
     */
    static pointInPolygon = function (polygonlatlng: any, pointlatlng: any) {
        //use latlng as inputs and convert to array
        let polygon:any  = [];
        polygonlatlng.forEach((p:any)=>{
            polygon.push([p.lng,p.lat]);
        });
        let point = [pointlatlng.lng,pointlatlng.lat];
        //A point is in a polygon if a line from the point to infinity crosses the polygon an odd number of times
        let odd = false;
        //For each edge (In this case for each point of the polygon and the previous one)
        for (let i = 0, j = polygon.length - 1; i < polygon.length; i++) {
            //If a line from the point into infinity crosses this edge
            if (((polygon[i][1] > point[1]) !== (polygon[j][1] > point[1])) // One point needs to be above, one below our y coordinate
                // ...and the edge doesn't cross our Y corrdinate before our x coordinate (but between our x coordinate and infinity)
                && (point[0] < ((polygon[j][0] - polygon[i][0]) * (point[1] - polygon[i][1]) / (polygon[j][1] - polygon[i][1]) + polygon[i][0]))) {
                // Invert odd
                odd = !odd;
            }
            j = i;
        }
        //If the number of crossings was odd, the point is in the polygon
        return odd;
    };

    static interpolate = function(p: any, pCenter:any, scaleFactor: number){
        let lat = pCenter.lat + (p.lat - pCenter.lat) * scaleFactor 
        let lng = pCenter.lng + (p.lng - pCenter.lng) * scaleFactor
        return {lat,lng} 
    }
    
    static distance = function(p:any, pFrom: any){
        const r_earth = 6371000; //in meter
        let dLng = (p.lng - pFrom.lng) * r_earth * Math.cos(p.lat * Math.PI/180);
        let dLat = (p.lat - pFrom.lat) * r_earth

        return {dLng: dLng,dLat: dLat};
    }

}